var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmail = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20 3.25H4A2.75 2.75 0 0 0 1.26 6v12A2.76 2.76 0 0 0 4 20.75h16A2.76 2.76 0 0 0 22.75 18V6A2.76 2.76 0 0 0 20 3.25zM21.25 18A1.25 1.25 0 0 1 20 19.25H4A1.25 1.25 0 0 1 2.75 18V6A1.25 1.25 0 0 1 4 4.75h16A1.25 1.25 0 0 1 21.25 6z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m20 8-8 5-8-5V6l8 5 8-5v2z"
})));
export default SvgEmail;